import { useShareTokenContext } from '../contexts/ShareTokenContext';

export const useShareTokenInput = (): { shareToken?: string } => {
  const { rawToken } = useShareTokenContext();
  return rawToken !== null ? { shareToken: rawToken } : {};
};
